import { DEFAULT_PARAMS, objectsRHandler } from '@/utils/objectsRHandler';

import AttributeAutocomplete from '../list/attribute/autocomplete';
import { apiService } from '@/services/APIService';
import { rHandler } from '@/plugins/RHandler';
import { PER_PAGE } from '@/constants/pagination';

export const AttributeManager = {
  get autocompletes() {
    const path = 'user-attribute-autocompletes';
    return {
      ...objectsRHandler(path, AttributeAutocomplete),
      memberIndex({ params, obs } = DEFAULT_PARAMS) {
        return rHandler(
          apiService.get(path, {
            ...params,
            expand: 'attribute',
            'per-page': PER_PAGE.infinity,
          }),
          (response) => ({
            response,
            items: response.data.data
              .map((i) => new AttributeAutocomplete(i, path))
              .filter(({ attribute: { settings } }) => (settings.system_attribute || settings.association_attribute) && !settings.assign),
          }),
          (error) => ({ error }),
          obs,
        );
      },
    };
  },
};
